import React, {useEffect, useState} from "react";
import {risksList} from "../../utils/staticInfos";
import {mountFormattedOverlay} from "../../utils/overlaysUtils";
import {MiniMapWithTiles} from "./MiniMapWithTiles";

export const MiniMapRisksWidget = ({summary, address, outlineCity, risks}) => {
    const [layers, setLayers] = useState([]);

    useEffect(() => {
        let list = risks
            .map(i => risksList[0].items.find(r => r.id === i))
            .filter(i => {
                let summaryRiskNode = i.summaryRiskNode(summary);
                return summaryRiskNode && summaryRiskNode.data && ((Array.isArray(summaryRiskNode.data) && summaryRiskNode.data.length > 0) || summaryRiskNode.data.score || summaryRiskNode.data === true);
            })
            .map(i => ({...mountFormattedOverlay(i, summary), details: null}));
        setLayers(list);
    }, [summary]);

    return (
        <div className="dashboard__body__map__container">
            <MiniMapWithTiles
                layers={layers}
                locationInfos={{com: summary.commune, address}}
                outlineCity={outlineCity.COM}
                initialBaseLayer={'plan'}
                showLayersLegendControl={true}
            />
        </div>
    )
}